import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import { getStringDateName } from '../../../utils/utils';
import i18n from '../../../translations/strings';
import EditText from '../../base/edit-text/edit-text';
import Button from '../../base/button/button';
import { SendEmailModalStyled } from './send-email-modal.styled';

export interface SendEmailModalProps {
  isVisible: boolean,
  onModalClose: () => void
  selectedReservation: any
  onSendEmail: (emailMessage: string) => void
}
const SendEmailModal = (props: SendEmailModalProps) => {

  const [messageEmail, setMessageEmail] = useState('')

  return (
    <Modal open={props.isVisible} onClose={() => { props.onModalClose(); setMessageEmail('') } }>
      <SendEmailModalStyled.ModalContainerContent>
        {
          props.selectedReservation &&
          <SendEmailModalStyled.ContentModal>
            <SendEmailModalStyled.ContainerMessageEmail>
              <SendEmailModalStyled.TitleModal>{`${i18n.t('sendEmail.titleEmail')} ${getStringDateName(props.selectedReservation?.created_at)} `}</SendEmailModalStyled.TitleModal>
              <EditText
                placeholder={i18n.t('sendEmail.message')}
                onChange={(text: any) => setMessageEmail(text.target.value)}
                label={i18n.t('sendEmail.insertMessage')}
                multiline
              />
            </SendEmailModalStyled.ContainerMessageEmail>
            <SendEmailModalStyled.ButtonSend>
              <Button onClick={() => props.onSendEmail(messageEmail)} label={i18n.t('sendEmail.send')} />
            </SendEmailModalStyled.ButtonSend>
          </SendEmailModalStyled.ContentModal>
        }
      </SendEmailModalStyled.ModalContainerContent>
    </Modal>
  );
};

export default SendEmailModal;
